import { Controller } from 'stimulus';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { getBreakpointValue } from '../tailwindhelpers';

gsap.registerPlugin(ScrollToPlugin);

export default class extends Controller {
  static targets = ['trigger'];

  connect() {
    document.addEventListener('turbo:load', this.checkBreakpoint());
  }

  scroll(event) {
    event.preventDefault();
    const scrollTarget = document.querySelector(event.target.hash);

    if (scrollTarget != null) { 
      gsap.to(window, {
        duration: .5,
        scrollTo: {
          y: scrollTarget,
          offsetY: document.querySelector('body > header').getBoundingClientRect().height - 4,
        },
      })
    }
  }

  checkBreakpoint() {
    if (window.innerWidth < getBreakpointValue('md') && document.querySelector('.filters')) {
      const height =  document.querySelector('.filters').getBoundingClientRect().height; 
      document.body.style.paddingBottom = height + 'px';
    } else {
      document.body.style.paddingBottom = '0px';
    } 
  }
}